import { ApplicationState } from '@/features/publicDatasets/types';

export const getQueryBuilderState = (state: ApplicationState) => ({
  showChartingOptions: state.layers.showChartingOptions,
  dataPresentation: state.rows.dataPresentation,
  rowRequestId: state.rows.rowRequestId,
  layers: state.layers.all,
  selectedLayerId: state.layers.selectedLayerId,
  tablesLoaded: state.datasource.tables != null,
  headings: state.rows.headings,
  userActions: state.datasource.userActions,
});

export const getResetQueryValidationValues = (state: ApplicationState) => ({
  metadata: state.rows.metadata,
  metadataChanged: state.rows.metadataChanged,
  layers: state.layers.all,
  selectedLayerId: state.layers.selectedLayerId,
});
